import { generateCSSRule, generateCSSSupportRule } from 'fela-utils';

export default function generateRule(selector, declaration) {
  var support = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  var rule = generateCSSRule(selector, declaration);

  if (support.length > 0) {
    return generateCSSSupportRule(support, rule);
  }

  return rule;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-dom/es/dom/generateRule.js
// module id = 851
// module chunks = 1